import { render, staticRenderFns } from "./vueVKYC.vue?vue&type=template&id=1bda7724"
import script from "./vueVKYC.vue?vue&type=script&lang=js"
export * from "./vueVKYC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports